import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { ChainHealthComponent } from '@app/features/chain-health/modules/chain-health/chain-health.component';
import { Authority } from '@app/shared/utils/enums';

export const chainHealthRoutes: Routes = [
    {
        path: 'chain-health',
        children: [
            {
                path: '',
                component: ChainHealthComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]